import type { ProductRestrictionFlag } from "../types/productV3";

export function hasProductRestrictions(
  restrictionFlags: readonly ProductRestrictionFlag[] | null | undefined
): boolean {
  return Array.isArray(restrictionFlags) && restrictionFlags.length > 0;
}
